import React, { Component } from "react";
import { connect } from "react-redux";

import OrgTable from "./component/orgTable";
import NavBar from "../../../_components/common/Navbar";
import Footer from "../../../_components/common/Footer";
import { organisationAction } from "../../../_actions/organisation.action";

class Organisation extends Component {
  state = {
    callCounter: 0,
  };
  componentDidMount() {
    const { dispatch } = this.props;
  
    dispatch(organisationAction.getOrganisation(() => {}));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error) {
      const { error, dispatch } = this.props;
      const that = this;
      if (error === true && this.state.callCounter < 2) {
        setTimeout(() => {
          dispatch(organisationAction.getOrganisation(() => {}));
          that.setState({
            callCounter: that.state.callCounter + 1,
          });
        }, 2000);
      }
    }
  }

  render() {
    return (
      <div>
        <NavBar />
        <div className="container custom-container my-5">
          <OrgTable heading="ORGANISATIONS" load={this.props.loading} />
        </div>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  const loading = state.organisation.loading;
  const error = state.organisation.error;

  return {
    alert,
    loading,
    error,
  };
}

export default connect(mapStateToProps)(Organisation);



// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/index.js